import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const HelperContainer = styled.div`
  display: none;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    display: block;
    background: linear-gradient(135deg, ${theme.colors.primaryLight}15, ${theme.colors.primary}10);
    border: 1px solid ${theme.colors.primary}30;
    border-radius: ${theme.radii.md};
    padding: ${theme.spacing.md};
    margin-bottom: ${theme.spacing.lg};
  }
`;

const HelperTitle = styled.h4`
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.sm};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`;

const HelperText = styled.p`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.secondary};
  line-height: 1.5;
  margin: 0;
`;

const StepList = styled.ol`
  margin: ${theme.spacing.sm} 0 0 0;
  padding-left: ${theme.spacing.lg};
  
  li {
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.text.secondary};
    margin-bottom: ${theme.spacing.xs};
  }
`;

interface Props {
  stage: 'filling' | 'preview';
}

export const MobileHelper: React.FC<Props> = ({ stage }) => {
  if (stage === 'filling') {
    return (
      <HelperContainer>
        <HelperTitle>
          <span>📝</span>
          How Mad Libs Work
        </HelperTitle>
        <HelperText>
          Fill in the blanks below to create your perfect prompt:
        </HelperText>
        <StepList>
          <li>Tap each highlighted blank field</li>
          <li>Choose from suggestions or type your own</li>
          <li>Required fields are marked with *</li>
          <li>Complete all blanks to see your final prompt</li>
        </StepList>
      </HelperContainer>
    );
  }
  
  return null;
};